import { render } from "./confirmBook.vue?vue&type=template&id=1ba95dd8&scoped=true"
import script from "./confirmBook.vue?vue&type=script&lang=js"
export * from "./confirmBook.vue?vue&type=script&lang=js"

import "./confirmBook.vue?vue&type=style&index=0&id=1ba95dd8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ba95dd8"]])

export default __exports__